import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { conf } from 'apps/home/fileFormats/formats.yaml';

import Paragraph from 'components/Paragraph';

import { MainWrapper } from 'legacyComponents/styled/lib';
import { THead } from 'apps/payment/styles';
import { Table, Th, Td } from 'apps/home/fileFormats/styles';

const FileFormatsTable = props => {
  const { marginTopBottom } = props;
  return (
    <MainWrapper marginTop={marginTopBottom} marginBottom={marginTopBottom}>
      <Table first>
        <THead>
          <tr>
            <Th>
              <Paragraph>
                <strong>
                  <Trans>Format</Trans>
                </strong>
              </Paragraph>
            </Th>
            <Th center>
              <Paragraph>
                <strong>
                  <Trans>Version</Trans>
                </strong>
              </Paragraph>
            </Th>
            <Th center>
              <Paragraph>
                <strong>
                  <Trans>Extensions</Trans>
                </strong>
              </Paragraph>
            </Th>
          </tr>
        </THead>
        <tbody>
          {Object.keys(conf.formats).map(entry => {
            const format = conf.formats[entry];
            return (
              <tr key={`${entry}-row`}>
                <Td>
                  <strong>{entry}</strong>
                </Td>
                <Td center>{format.version}</Td>
                <Td center>{format.extensions.join(', ')}</Td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </MainWrapper>
  );
};

FileFormatsTable.propTypes = {
  marginTopBottom: '0',
};

FileFormatsTable.propTypes = {
  marginTopBottom: PropTypes.string,
};

export default withNamespaces()(FileFormatsTable);
